import React from 'react';
import {Link} from "react-router-dom";
import GlassyButton from "./GlassyButton";

import './Hero.css';
import {useRates} from "../hooks/useRates";

import exchange_img from '../assets/exchange.jpg';

import exchange_icon from '../assets/icons/arrow.svg';
import CountUp from "react-countup";


const Hero = () => {


    const rates = useRates();


    const ratesMap = [

        {
            action: 'Покупаем',
            price: rates?.buyRate || 0,
        },
        {
            action: 'Продаем',
            price: rates?.sellRate || 0,
        },
    ]


    const handleClick = () => {
        const username = "obmenvpermi";
        const url = `https://t.me/${username}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };



    return (
        <div className={'hero-wrapper card'}>

            <div className={'hero-bg-img-container'}>
                <img className={'hero-bg-img'} src={exchange_img} alt="exchange"/>
            </div>

            <div className={'hero-container'}>

                <div className={'hero-text'}>
                    <h1 className={''} style={{marginBottom: '-6px'}}>Обмен криптовалют <span className={''}>в Перми</span></h1>
                    <p className={'p opacity75'}>Вы можете рассчитать сумму, связаться с оператором и перейти к обмену одним нажатием</p>
                </div>


                <div className={'hero-bottom'}>


                    <div className={'hero-rates-wrapper'}>


                        <h3 className={'hero-rates-pair h3 normal uppercase'}>
                            <span className={'bold'}>USDT</span><img className={'hero-rates-pair-icon'}
                                                                     src={exchange_icon} alt="Exchange"/><span
                            className={''}>RUB</span>
                        </h3>


                        <div className={'hero-rates-container'}>

                            {
                                ratesMap?.map((rate, rateIndex) =>

                                    <div className={'hero-rate'} key={rateIndex}>

                                        <h4 className={'h4 opacity75 normal uppercase'}>
                                            {rate.action}
                                        </h4>

                                        {/*<h1 className={'wide'}>
                                            {rate.price.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </h1>*/}

                                        <h1 className="mono wide">
                                            <CountUp
                                                className={'mono wide'}
                                                start={0}
                                                end={rate.price}
                                                duration={0.75}
                                                decimals={2}
                                                separator=" "
                                                decimal=","
                                                enableScrollSpy={true} // запустится при попадании во viewport
                                                scrollSpyOnce={false}   // только один раз
                                            />
                                        </h1>

                                    </div>
                                )
                            }

                        </div>


                    </div>


                    <Link
                        to={'/exchange'}
                        style={{width: '100%', maxWidth: '100%'}}
                    >
                        <button className={'btn white-gradient full'} style={{width: '100%', maxWidth: '100%'}}>
                            Рассчитать обмен
                        </button>
                    </Link>


                    <GlassyButton onClick={() => handleClick()} className={'full'}>
                        Связаться с Нами
                    </GlassyButton>

                </div>

            </div>

        </div>
    );
};

export default Hero;